import React from 'react'

const NoData = () => {
  return (
    <div className='nodata'>
        <img src="/assets/images/animate_icon4.webp" alt="" />
        <h4>Sorry, no results found!</h4>
    </div>
  )
}

export default NoData